export interface SalesCommissionInvoicesCreated {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  createdBy: string;
  customerKey: string;
  customerName: string;
  currencyCode: string;
  salesOrderAndLineNo: string;
  invoiceItemTotal: number;
  invoiceDeliveryTotal: number;
  invoiceExtraTotal: number;
  invoiceNettTotal: number;
  invoiceTaxTotal: number;
  invoiceOverallTotal: number;
}
